export const ATTACH_ACCEPT = ".pdf,.docx,.txt,.md,.csv,.xlsx,.jpg,.jpeg,.png,.heic,.heif";
export const ATTACH_EXTS = [".pdf", ".docx", ".txt", ".md", ".csv", ".xlsx", ".jpg", ".jpeg", ".png", ".heic", ".heif"];

export function isAcceptedFile(file) {
  const name = (file?.name || "").toLowerCase();
  return ATTACH_EXTS.some((ext) => name.endsWith(ext));
}

export function filesFromList(list) {
  return Array.from(list || []).filter(isAcceptedFile);
}

export function attachStatusLabel(item) {
  const name = item?.name || "arquivo";
  if (item.status === "uploading") return `Enviando ${name}…`;
  if (item.status === "reading") return `Lendo ${name}…`;
  if (item.status === "done") return `${name} lido`;
  if (item.status === "error") return `Não li ${name}`;
  return name;
}

export function fileKind(name) {
  const n = (name || "").toLowerCase();
  if (n.endsWith(".pdf")) return "PDF";
  if (n.endsWith(".docx")) return "DOCX";
  if (n.endsWith(".txt") || n.endsWith(".md")) return "TXT";
  if (n.endsWith(".csv")) return "CSV";
  if (n.endsWith(".xlsx")) return "XLSX";
  if (n.endsWith(".heic") || n.endsWith(".heif")) return "IMG";
  if (n.endsWith(".jpg") || n.endsWith(".jpeg") || n.endsWith(".png")) return "IMG";
  return "DOC";
}

export function promptToUseDoc(filename) {
  return `Use o documento "${filename}" que já está nesta conversa. Extraia o que for útil e aplique agora.`;
}

const SYSTEM_PREFIX = "[DOCUMENTO ANEXADO:";
const LEGACY_PREFIX = "📎 Documento anexado:";

export function attachmentFromMessage(message) {
  if (!message) return null;
  const content = message.content || "";
  if (message.role === "system") {
    const filename = message.metadata?.filename
      || (content.startsWith(SYSTEM_PREFIX)
        ? content.slice(SYSTEM_PREFIX.length).split("]")[0].trim()
        : null);
    if (!filename) return null;
    const body = content.startsWith(SYSTEM_PREFIX)
      ? content.slice(content.indexOf("]") + 1).trim()
      : content;
    return {
      id: message.id,
      filename,
      truncated: Boolean(message.metadata?.truncated),
      text: body,
    };
  }
  if (message.role === "user" && content.startsWith(LEGACY_PREFIX)) {
    const filename = content.split("\n")[0].replace(LEGACY_PREFIX, "").trim();
    return { id: message.id, filename, truncated: false, text: content };
  }
  return null;
}

export function messageFromAttach(data) {
  return {
    id: data?.id || `att-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    role: "system",
    content: data?.text || "",
    metadata: {
      kind: "attachment",
      filename: data?.filename,
      truncated: Boolean(data?.truncated),
    },
  };
}

export function docsFromMessages(messages) {
  const seen = new Set();
  const out = [];
  for (const m of messages || []) {
    const doc = attachmentFromMessage(m);
    if (!doc || seen.has(doc.filename)) continue;
    seen.add(doc.filename);
    out.push(doc);
  }
  return out;
}
